import React, {useEffect} from 'react';
import {motion} from 'framer-motion';
import {Outlet, useLocation} from 'react-router';
import useHelmet from 'utilities/hooks/helmet/useHelmet';

const ChatLayout = () => {
  useHelmet('چت');
  const {pathname} = useLocation();
  useEffect(() => {
    document.body.className = 'theme-wholesaler';
    return () => {
      document.body.className = '';
    };
  }, []);

  return (
    <div className=" h-screen flex flex-col theme-wholesaler relative bg-gradient-to-b via-[#F9F9F9] from-white to-[#f4f4f4]">
      <motion.div
        key={pathname}
        initial={{opacity: 0, x: '100%'}}
        animate={{opacity: 1, x: 0}}
        exit={{opacity: 0, x: '-100%'}}
        transition={{duration: 0.2}}
        className="grow"
      >
        <div className="grow h-full">
          <Outlet />
        </div>
      </motion.div>
    </div>
  );
};

export default ChatLayout;
